<template>
  <Card title="greeting-first">
    <InfoUser :data="userDetails" />
    <PaymentDetail isVertical="false" :data="paymentDetail" />

    <div class="w-full">
      <div class="max-w-buttonCover mx-auto mt-20 w-full" v-if="payment.status === 'PAYMENT'">
        <button @click.prevent="handleTinabaPay" class="btn btn-blue text-20 font-black block w-full"> {{ $t("payment-type-tinaba") }} </button>
      </div>
    </div>
    <div class="md-max:max-w-buttonCover md-max:mx-auto md:flex grid-cols-3 w-full justify-center items-center">
      <paypal-pay :payment="payment" v-if="payment.paypalVas && paypalData" />
      <button v-if="payment.paypalCardVas && paypalData && cardEligible()" @click.prevent="handleCardPay" class="btn md:w-4/12 md:mx-2 btn-blue-hollow mt-3 block w-full"> {{ $t("payment-type-card") }} </button>
      <button v-if="payment.connectVas" @click.prevent="startAliPayCheckout" class="btn md:w-4/12 md:mx-2 btn-blue-hollow mt-3 block w-full relative alipay-btn">
        <vue-image id="alipay" class="fit fit-contain" src="/alipay+comp.png" />
        <vue-image id="alipay_hover" class="fit fit-contain" src="/alipay+comp_hover.png" />
      </button>
    </div>
  </Card>
</template>

<script>
import InfoUser from '@/components/InfoUser.vue'
import PaymentDetail from '@/components/PaymentDetail.vue'
import Card from '@/components/Card.vue'
import VueImage from '@/components/Image'
import { mapActions } from 'vuex'
import linkToPayData from '@/mixins/linkToPayData.js'
import PaypalPay from './PaypalPay'

export default {
  name: 'Home',
  mixins: [linkToPayData],
  components: {
    Card,
    InfoUser,
    PaymentDetail,
    VueImage,
    PaypalPay
  },
  methods: {
    ...mapActions('linkToPay', ['startAliPayCheckout']),
    cardEligible () {
      return window.paypal.HostedFields.isEligible()
    }
  },
  created () {
    this.initPolling()
  }
}
</script>

<style lang="css">
  .alipay-btn .img__el {
    height: 80%;
    top: 15%;
  }
  #alipay_hover{
    display: none;
  }
  .alipay-btn:hover #alipay_hover {
    display: block;
  }
  .alipay-btn:hover #alipay {
    display: none;
  }
</style>
